import React, { useRef } from "react";
import { useReplaceFile } from "../hooks/useReplaceFile";
import { en } from "../i18n/en";

interface ReplaceFileButtonProps {
  documentId: number;
  /** Called after file replacement starts successfully (OCR job queued) */
  onStarted?: () => void;
}

export const ReplaceFileButton: React.FC<ReplaceFileButtonProps> = ({
  documentId,
  onStarted,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const { mutate, isPending } = useReplaceFile(documentId);

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    inputRef.current?.click();
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) {
      return;
    }
    const formData = new FormData();
    formData.append("file", file);
    mutate(formData, {
      onSuccess: () => {
        onStarted?.();
      },
    });
    e.target.value = "";
  };

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept="application/pdf,image/*"
        className="hidden"
        onChange={handleChange}
        data-testid={`replace-file-input-${documentId}`}
      />
      <button
        type="button"
        disabled={isPending}
        onClick={handleClick}
        className="mt-2 flex items-center gap-2 rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50"
        data-testid={`replace-file-button-${documentId}`}
      >
        {isPending ? en.pending.replaceFileLoading : en.pending.replaceFile}
      </button>
    </>
  );
};
